module.exports = __webpack_public_path__ + "img/image_formatA.a358264c.png";